import { Drawer } from 'antd';
import React, { FC } from 'react';

import BaseModal from '@/components/CartPage/AddressesModal/BaseModal';
import { montserrat } from '@/components/Layout';

import { Address } from '@/utils/interfaces/Manage-Addresses';

interface Props {
  open: boolean;
  onCancel?:
    | ((e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  onOk?:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  addresses: Address[] | undefined;
  onSelect?: (e: Address) => void;
  selectedAddress?: Address | null;
  onClickCreate?: () => void;
  onClickEdit?: (address: Address) => void;
}

const AddressResponsiveSheet: FC<Props> = ({
  open,
  onCancel,
  addresses,
  onSelect,
  selectedAddress,
  onClickCreate,
  onClickEdit,
}) => {
  return (
    <Drawer
      classNames={{
        // content: 'h-[80vh]',
        mask: 'bg-black/[80%]',
        wrapper: ' h-auto',
        body: 'max-h-[80vh] overflow-auto zai-scrollbar bg-grayZl-950',
      }}
      title={false}
      closeIcon={false}
      open={open}
      onClose={() => onCancel?.()}
      placement='bottom'
      style={{
        fontFamily: montserrat.style.fontFamily,
      }}
    >
      <BaseModal
        varient="sheet"
        onCancel={onCancel}
        addresses={addresses}
        onSelect={onSelect}
        selectedAddress={selectedAddress}
        onClickCreate={onClickCreate}
        onClickEdit={onClickEdit}
      />
    </Drawer>
  );
};

export default AddressResponsiveSheet;
